module.exports = __webpack_public_path__ + "img/win-s2-10.1ed89699.png";